import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   

    getMenuIndex(state,value){
        
        
       
        post(urls.admin.menu.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
        
       
           
        });
        
    },
   

    addMenu(state,value){
        
        

        post(urls.admin.menu.add,value).then((result)=>{
          

          
          state.result=result
        
       
        
       
           
        });
        
    },
    editMenu(state,value){



        post(urls.admin.menu.edit,value).then((result)=>{



            state.result=result





        });

    },
    deleteMenu(state,value){



        post(urls.admin.menu.delete,value).then((result)=>{



            state.result=result





        });

    },
    getPermissionMenu(state,value){



        post(urls.admin.menu.permission,value).then((result)=>{



            state.result=result





        });

    },

    
   

    

}
const  actions={


    getMenuIndexAction(context,value){
       
        context.commit("getMenuIndex",value)
       
    },
  
    addMenuAction(context,value){
       
        context.commit("addMenu",value)
       
    },
    editMenuAction(context,value){

        context.commit("editMenu",value)

    },
    deleteMenuAction(context,value){

        context.commit("deleteMenu",value)

    },
    getPermissionMenuAction(context,value){

        context.commit("getPermissionMenu",value)

    },


    
    

}

export default {state,mutations,actions}